import Connection from './Connection.js'
import axios from 'axios'

global.axios = axios;

function genCode(length=5) {
  let result           = '';
  let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let charactersLength = characters.length;
  for(let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * 
    charactersLength));
  }
  return result;
}

function shuffleArray(array) {
  for(let i = array.length - 1; i >= 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

const OPENAI_API_KEY = atob('c2stcHJvai1CRlRqMjQ3OWhCbkVQWGZsRDhtTWJubHJibWI0ZWRQWDQtZTRzaTV1Q1dYX3RNZ2w2dDk1dGZVN3M0NzAteTM2TUVXNkNseVpld1QzQmxia0ZKUi1VbktaZjR6ckJNQUVid1RwWENfNVY2eVZjRktzczRmNldHUktTY2lBTEtPeGhCUzEzOG9uM3JRbUdRRzNVUVpaLU14MXRuOEE=');
const MOVIEDB_API = atob('ZXlKaGJHY2lPaUpJVXpJMU5pSjkuZXlKaGRXUWlPaUpqT1dKa09HUmtabVZpWm1Ka01EbG1aVE16WXpnMllUTmxZakUyTXpGa1l5SXNJbTVpWmlJNk1UY3lOemd4TURjMk5DNHpPVFlzSW5OMVlpSTZJalkyWm1NMFkyTmpNREpsTW1VelptRTBZV0UyT0RZMk1pSXNJbk5qYjNCbGN5STZXeUpoY0dsZmNtVmhaQ0pkTENKMlpYSnphVzl1SWpveGZRLkRMaEw1NG5wbmJKY3NJcUM4aW92V00wcHBkd0lkclltX0pDc25qc2JWMHc=');

class Host extends Connection {
  constructor(name, options={}) {
    let hostCode = options.code ?? genCode();
    super(hostCode, name, options);

    this.peer.on('open', () => {
      this.ping_interval = setInterval(() => {
        for(let conn of Object.values(this.peer.connections)) {
          conn[0]?.send({
            type: 'ping',
          });
        }
      }, 30_000);

      this.options.onReady?.();
    });

    this.peer.on('close', () => {
      clearInterval(this.ping_interval);
    });

    let settings = {};
    if(window.localStorage.getItem('settings') !== null) {
      try {
        Object.assign(settings, JSON.parse(window.localStorage.getItem('settings')));
      }
      catch(err) {}
    }
    this.setState({
      state: 'open',
      ready: false,
      members: {
        [this.ID]: {
          name,
          films: this.mesFilms,
        },
      },
      settings,
    });

    this.hostCode = hostCode;

    this.host = true;

    this.peer.on('connection', conn => {
        // console.log('Connection !', conn)
      const ID = conn.peer;
      let member = {ID};

      conn.on('data', data => {
        // console.log(data)

        if(data.type === 'sync') {
          Object.assign(member, data.data);
          this.updateMember(ID, data.data);
        }
        else if(data.type === 'submit') {
          this.submit();
        }
        else if(data.type === 'vote') {
          for(let f of this.state.films) {
            if(f.name === data.film) {
              if(f.members.includes(member.name))
                return;
            }
          }

          this.setState({
            ...this.state,
            votes: {
              ...this.state.votes,
              [member.name]: data.film,
            },
          });
        }
      });

      conn.on('close', () => {
        // console.log('CLOSE !')
        let state = {
          ...this.state,
          members: {
            ...this.state.members,
          },
        };
        delete state.members[ID];
        this.setState(state);
      });
    });
  }

  updateMember(ID, data) {
    let members = {
      ...this.state.members,
      [ID]: {ID, ...data},
    };

    this.setState({
      ...this.state,
      members,
    });
  }

  syncToAll(except=null) {
    for(let [ID, conns] of Object.entries(this.peer.connections)) {
      if(ID === this.ID || ID === except)
        continue;
      conns[0]?.send({
        type: 'sync',
        state: this.state,
      });
    }
  }

  setState(state) {
    if(state.state === 'open') {
      let nbr_films = state.settings.nbr_films;
      let ready = true;
      for(let member of Object.values(state.members)) {
        if(member.films.length != 0 && member.films.length != nbr_films) {
          ready = false;
          break;
        }
      }
      state.ready = ready;
    }
    else if(state.state === 'vote') {
      let ready = true;
      for(let vote of Object.values(state.votes)) {
        if(vote === null) {
          ready = false;
          break;
        }
      }
      state.ready = ready;
    }

    super.setState(state);
    this.syncToAll();
  }

  setMesFilms(mesFilms) {
    if(this.state.state !== 'open')
      return;

    super.setMesFilms(mesFilms);

    let ID = this.ID;
    this.updateMember(this.ID, {
      ...this.state.members[ID],
      films: mesFilms,
    });
  }

  async submit() {
    if(this.state.state === 'open') {
      // tirage au sort
      if(this.state.settings.type === 'tirage_au_sort') {
        let films = [];
        for(let m of Object.values(this.state.members)) {
          let key = 1;
          for(let f of m.films)
            films.push({...f, member: m.name, key: key++});
        }

        let winner = films[Math.floor(Math.random() * films.length)];

        // for(let conn of Object.values(connection.peer.connections)) {
        //   conn[0].send({
        //     type: 'winner',
        //     winner,
        //   });
        // }

        this.setState({
          state: 'finished',
          winner,
        });
      }
      // vote
      else {
        this.setState({
          ...this.state,
          loading: true,
        });

        let films = [];
        let votes = {};

        for(let m of Object.values(this.state.members)) {
          let key = 1;
          for(let f of m.films)
            films.push({...f, member: m.name, key: key++});
          votes[m.name] = null;
        }

        shuffleArray(films);

        let prompt = this.getSetting('resume_prompt')+"\n";
        for(let f of films) {
          prompt += `"${f.name}" sorti en ${f.annee}`+"\n";
        }

        await Promise.all(films.map(f => {
          // f.movie_id = f.name;
          // f.date = '2024-12-01';
          // f.duree = 128;
          // f.genre = 'Drame, Test';
          // f.note = 5.6;
          // return null;

          return axios.get('https://api.themoviedb.org/3/search/movie', {
            params: {
              'query': f.name,
              'include_adult': 'false',
              'language': 'fr-FR',
              'page': '1'
            },
            headers: {
              'Authorization': 'Bearer '+MOVIEDB_API,
              'accept': 'application/json'
            }
          })
            .then(res => {
              // console.log(res.data);

              let movie_id = res.data.results[0]?.id;
              f.move_id = movie_id;

              if(!movie_id)
                return;

              return axios.get('https://api.themoviedb.org/3/movie/'+movie_id, {
                params: {
                  'language': 'fr-FR'
                },
                headers: {
                  'Authorization': 'Bearer '+MOVIEDB_API,
                  'accept': 'application/json'
                }
              })
                .then(res2 => {
                  // console.log(res2.data);
                  let data = res2.data;

                  if(data.poster_path)
                    f.image = 'https://image.tmdb.org/t/p/w300_and_h450_bestv2/'+data.poster_path;
                  f.resume = data.overview;
                  f.date = data.release_date;
                  f.annee = data.release_date ? data.release_date.split('-')[0] : null;
                  f.duree = data.runtime;
                  f.genre = data.genres.map(a => a.name).join(', ');
                  f.note = data.vote_average;

                  // console.log(f);
                })
                .catch(err => {});
            })
            .catch(err => {})
            ;
        }));

        // dédoubler les films
        let tmp = [];
        let movies_by_id = {};
        for(let f of films) {
          f.members = [f.member];
          if(f.movie_id) {
            if(f.movie_id in movies_by_id)
              movies_by_id[f.movie_id].members.push(f.member);
            else {
              tmp.push(f);
              movies_by_id[f.movie_id] = f;
            }
          }
          else
            tmp.push(f);
        }
        films = tmp;

        // for(let f of films)
        //   f.resume = 'test resume';
        if(this.getSetting('infos_resume_chatgpt') || this.getSetting('image_prompt').includes(':resume_chatgpt')) {
          await axios.post(
            'https://api.openai.com/v1/chat/completions',
            {
              'model': 'gpt-5.4-mini',
              'store': true,
              'messages': [
                {
                  'role': 'user',
                  'content': prompt,
                }
              ],
              "response_format": {
                "type": "json_schema",
                "json_schema": {
                  "name": "response",
                  "strict": true,
                  "schema": {
                    "type": "object",
                    "properties": {
                      "resumes": {
                        "type": "array",
                        "items": {
                          "type": "string"
                        }
                      }
                    },
                    "required": [
                      "resumes"
                    ],
                    "additionalProperties": false
                  }
                }
              },
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+OPENAI_API_KEY
              }
            }
          )
            .then(res => {
              // console.log(res.data);

              let resumes;
              try {
                resumes = JSON.parse(res.data.choices[0].message.content).resumes;
              }
              catch(err) {
                return;
              }

              for(let i in resumes)
                films[i].resume_chatgpt = resumes[i];
            })
            .catch(err => {
              console.log(err);
            })
        }

        if(this.getSetting('infos_image_chatgpt')) {
          let promises = [];

          const IMAGES_RATE = 5;

          for(let f of films) {
            if(promises.length >= IMAGES_RATE) {
              await Promise.all(promises);
              promises = [];
              await new Promise(resolve => setTimeout(resolve, 60*1_000));
            }

            let prompt = this.getSetting('image_prompt');
            if(prompt.includes(':resume_chatgpt')) {
              if(!f.resume_chatgpt)
                return null;
              prompt = prompt.replaceAll(':resume_chatgpt', f.resume_chatgpt);
            }
            if(prompt.includes(':resume')) {
              if(!f.resume)
                return null;
              prompt = prompt.replaceAll(':resume', f.resume);
            }
            if(prompt.includes(':titre')) {
              if(!f.name)
                return null;
              prompt = prompt.replaceAll(':titre', f.name);
            }
            if(prompt.includes(':annee')) {
              if(!f.annee)
                return null;
              prompt = prompt.replaceAll(':annee', f.annee);
            }

            promises.push(
              axios.post(
                'https://api.openai.com/v1/images/generations',
                {
                  'model': 'dall-e-3',
                  'n': 1,
                  'size': '1024x1024',
                  'prompt': prompt,
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+OPENAI_API_KEY
                  }
                }
              )
                .then(res => {
                  // console.log(res);
                  // console.log(res.data);
                  // console.log(res.data.data[0].url);
                  f.image_chatgpt = res.data.data[0].url;
                })
                .catch(err => {
                  console.log(err);
                })
            );
          }

          await Promise.all(promises);
        }

        this.setState({
          state: 'vote',
          films: films,
          votes,
          settings: this.state.settings,
          loading: false,
        });
      }
    }
    else if(this.state.state === 'vote') {
      // console.log(this.state)
      let votes = {};
      let max = 0;
      for(let vote of Object.values(this.state.votes)) {
        if(!vote)
          continue;

        if(vote in votes)
          votes[vote]++;
        else
          votes[vote] = 1;
        if(votes[vote] > max)
          max = votes[vote];
      }
      // console.log(votes)
      // console.log(max)

      let res = [];
      for(let [vote, c] of Object.entries(votes)) {
        if(c === max)
          res.push(vote);
      }
      // console.log(res)

      let results = this.state.results ? [...this.state.results] : [];
      results.push({...this.state.votes});

      if(res.length === 1) {
        let winner;

        for(let f of this.state.films) {
          if(f.name === res[0]) {
            winner = f;
            break;
          }
        }

        this.setState({
          state: 'finished',
          winner,
          results,
        });
      }
      else if(res.length === this.state.films.length) {
        let winner = this.state.films[Math.floor(Math.random() * this.state.films.length)];
        this.setState({
          state: 'finished',
          winner,
          results,
        });
      }
      else {
        let films = [];
        let votes = {};

        if(res.length > 0) {
          for(let f of Object.values(this.state.films)) {
            if(res.includes(f.name))
              films.push({...f});
          }
        }
        else
          films = this.state.films.map(a => ({...a}));

        for(let name of Object.keys(this.state.votes))
          votes[name] = null;

        this.setState({
          ...this.state,
          votes,
          films,
          results,
        });
      }
    }
  }

  setSetting(k, v) {
    if(this.state.state !== 'open')
      return;

    let settings = {
      ...this.state.settings,
      [k]: v,
    };

    window.localStorage.setItem('settings', JSON.stringify(settings));

    this.setState({
      ...this.state,
      settings,
    });
  }

  vote(film_name) {
    if(this.state.state !== 'vote')
      return;

    this.setState({
      ...this.state,
      votes: {
        ...this.state.votes,
        [this.name]: film_name,
      },
    });
  }

  kick(member) {
    for(let [ID, conns] of Object.entries(this.peer.connections)) {
      if(ID === member.ID) {
        conns.forEach(c => c.close());
      }
    }

    // this.setState({
    //   ...this.state,
    //   members: this.state.members.filter(m => m !== member),
    // });
  }
}

export default Host